import React from 'react';
import { Row, Col } from 'antd';
import {FormattedMessage} from 'react-intl';
import { compose, graphql } from 'react-apollo';
import {TOTAL_CONVERSIONS, TOTAL_DEVICES, TOTAL_VISITS} from "./gql/query";
import IconStat from './icon-stat'
import {Loading} from "../../utils/loading";

class Totals extends React.Component {
  render ()  {
    const {totalVisits, totalConversions, totalDevices} = this.props;
    const iconSpan = 4, iconStyle = { minWidth: '170px'};
    return (
      <Row type="flex" justify="space-between" gutter={8} style={{marginTop: '8px'}}>
        <Col span={iconSpan} style={iconStyle}>
          {totalVisits.loading ? <Loading style={{lineHeight: '56px'}}/> :
            <IconStat
              label={<FormattedMessage id="analytics.visits" defaultMessage="Визиты"/>}
              value={totalVisits.totalVisits}
            />
          }
        </Col>
        <Col span={iconSpan} style={iconStyle}>
          {totalConversions.loading ? <Loading style={{lineHeight: '56px'}}/> :
            <IconStat
              label={<FormattedMessage id="analytics.conversions" defaultMessage="Конверсии"/>}
              value={totalConversions.totalConversions}
            />
          }
        </Col>
        <Col span={iconSpan} style={iconStyle}>
          {totalDevices.loading ? <Loading style={{lineHeight: '56px'}}/> :
            <IconStat
              label={<FormattedMessage id="analytics.devices" defaultMessage="Устройства"/>}
              value={totalDevices.totalDevices}
            />
          }
        </Col>
        {/*<Col span={iconSpan} style={iconStyle}><IconStat*/}
        {/*label={<FormattedMessage id="analytics.saved" defaultMessage="Сэкономлено, руб."/>}*/}
        {/*value={1050}*/}
        {/*/></Col>*/}
        {/*<Col span={iconSpan} style={iconStyle}><IconStat*/}
        {/*label={<FormattedMessage id="analytics.fraud" defaultMessage="% Фрода"/>}*/}
        {/*value={'23'}*/}
        {/*/></Col>*/}
      </Row>
    )

  }
}

const queryOptions = ({dateFrom, dateTo, projects, labelType, labelValues, osGroups, browserGroups, trafficChannels, affiliateNetworks, deviceTypes, country, cities, region}) => {
  return {
    variables: { dateFrom, dateTo, projects, labelType, labelValues, osGroups, browserGroups, trafficChannels, affiliateNetworks, deviceTypes, country, cities, region},
    notifyOnNetworkStatusChange: true
  };
}

export default compose(
  graphql(TOTAL_VISITS, {
    options: queryOptions,
    name: 'totalVisits'
  }),
  graphql(TOTAL_CONVERSIONS, {
    options: ({dateFrom, dateTo, projects, labelType, labelValues, osGroups, browserGroups, trafficChannels, affiliateNetworks, deviceTypes, country, cities, region }) => {
      return {
        variables: { dateFrom, dateTo, projects, labelType, labelValues, osGroups, browserGroups, trafficChannels, affiliateNetworks, deviceTypes, country, cities, region },
        notifyOnNetworkStatusChange: true
      };
    },
    name: 'totalConversions'
  }),
  graphql(TOTAL_DEVICES, {
    options: queryOptions,
    name: 'totalDevices'
  })
)(Totals);


// WEBPACK FOOTER //
// ./src/components/dashboard/analytics/totals.js